/* v8 ignore start */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BaseWizard from 'containers/BaseWizard';
import SimpleSidebar from 'containers/BaseWizard/components/Sidebars/SimpleSidebar';

import ExamplePage from './components/ExamplePage';
import * as actions from './SimpleWizard.ducks';

const mapStateToProps = (
  (state) => ({
    wizardStore: state.SimpleWizard || {}
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class SimpleWizard extends Component {

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.handleOpen();
  }

  render() {
    const { wizardStore, handleClose } = this.props;
    return (
      <BaseWizard
        wizardStore={wizardStore}
        sidebarComponent={<SimpleSidebar title="Simple Sidebar" />}
        onClose={handleClose}
      >
        <ExamplePage
          title="Page One"
          pageHeader="Page One Header"
        />
        <ExamplePage
          title="Page Two but this is longer so that the text wraps"
          pageHeader="Page Two Header"
        />
        <ExamplePage
          title="Page Three"
          pageHeader="Page Three Header"
        />
      </BaseWizard>
    );
  }
}

SimpleWizard.propTypes = {
  wizardStore: PropTypes.object,
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
};

export default connect(mapStateToProps, actions, mergeProps)(SimpleWizard);
